import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Loader2, Eye } from 'lucide-react';
import { quotesApi } from '../api';
import { QuoteDocumentView } from '../../components/QuoteDocumentView';

export const QuotePreviewDialog = ({ open, onOpenChange, quoteId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    setData(null);
    quotesApi.preview(quoteId)
      .then((r) => setData(r.data.quote))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [open, quoteId]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} className="bg-[#0A0A0A] border-gray-800 text-white max-w-4xl max-h-[92vh] overflow-y-auto p-0" data-testid="quote-preview-dialog">
        <DialogHeader className="px-5 pt-5 pb-3">
          <DialogTitle className="flex items-center gap-2 text-white"><Eye size={16} className="text-[#D4AF37]" /> Customer Preview</DialogTitle>
        </DialogHeader>
        <div className="bg-[#D4AF37]/10 border-y border-[#D4AF37]/30 px-5 py-2 text-xs text-[#D4AF37]" data-testid="preview-banner">
          This is exactly what your customer will see when you share the quote link.
        </div>
        <div className="px-4 sm:px-6 py-5">
          {loading && <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#D4AF37]" size={26} /></div>}
          {!loading && data && <QuoteDocumentView q={data} previewMode />}
          {!loading && !data && <p className="text-gray-400 text-sm text-center py-10" data-testid="preview-error">Could not load preview.</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
